var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0C26.828 0 27.5 0.672 27.5 1.5V28.5C27.5 29.328 26.828 30 26 30H5C4.172 30 3.5 29.328 3.5 28.5V25.5H0.5V22.5H3.5V19.5H0.5V16.5H3.5V13.5H0.5V10.5H3.5V7.5H0.5V4.5H3.5V1.5C3.5 0.672 4.172 0 5 0H26ZM24.5 3H6.5V27H24.5V3ZM17 9V13.5H21.5V16.5H16.9985L17 21H14L13.9985 16.5H9.5V13.5H14V9H17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenda);
export default __webpack_public_path__ + "static/media/agenda.c8b2099d2549de407d766e5f40d52e8e.svg";
export { ForwardRef as ReactComponent };